export default __webpack_public_path__ + "static/media/slider-img-3.2b0a2655.png";